export enum ChangeTypeEnum {
  USER_UPDATE = 'USER_UPDATE',
  USER_CREATE = 'USER_CREATE',
  USER_DELETE = 'USER_DELETE',
  BATCH_UPDATE = 'BATCH_UPDATE',
  CHILD_CHANGE = 'CHILD_CHANGE',
  SILENT_CHANGE = 'SILENT_CHANGE',
}
